import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'
import { typography } from './typography'

export const GlobalStyle = createGlobalStyle`
:root {
// Colors
  --header-height: 11rem;
  --background: ${theme.colors.background};
  --text-color: ${theme.colors.text};
  --primary-color: ${theme.colors.red};
  --grey: ${theme.colors.grey};
  --border-color: ${theme.colors.border};
}

* {
  box-sizing: border-box;
}

html {
  font-size: 62.5%;
  scroll-behavior: smooth;
}

body {
  ${typography.text.md}
  margin: 0;
  padding: 0;
  color: ${theme.colors.text};
  background-color: ${theme.colors.background};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

`
